<template>
    <section class="content content--cabinet">
        <div class="small-window">
            <form class="form-wrap">
                <h1 class="form-wrap__title">{{$t('login.title')}}</h1>
                <div class="form-wrap__row">
                    <c-input
                            :label="$t('login.phone')"
                            :fieldName="'phone'"
                            :type="'tel'"
                            v-model="phone"
                            :mask="'+7(###)###-##-##'"
                            :validation="'required|min:16'"
                            :externalError="phoneExternalError"
                    ></c-input>
                </div>
                <div class="form-wrap__row">
                    <c-input-password
                            :label="$t('login.password')"
                            :fieldName="'password'"
                            :type="'password'"
                            v-model="password"
                            :externalError="passwordExternalError"
                    ></c-input-password>
                </div>
                <div class="form-wrap__row">
                    <div class="button-wrap">
                        <button class="button button--form button--yellow" v-on:click.prevent="login">{{$t('login.submit')}}</button>
                    </div>
                    <router-link class="router-link" :to="{name: 'ForgotPassword', params: {lang: this.$route.params.lang}}">Забыли пароль?</router-link>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import {TOGGLE_LOADER} from "../../../storage/mutations";
    import querystring from "querystring";
    import {STATUSES} from "../../../components/statuses";


    export default {
        name: "login",
        beforeRouteEnter: function(to, from, next){

            // TODO:  Поправить это место, сделать нормальный редирект
            next(_this => {

                _this.$store.commit(TOGGLE_LOADER, {state: true});
               _this.$http.get("/json/profile/check_auth").then(
                   response => {
                       _this.$store.commit(TOGGLE_LOADER, {state: false});
                       if (response.data.code === 0) {
                               _this.$router.push({name: 'CabinetIndex'})
                       }
                   }
                ).catch( (response) => {
                   _this.$store.commit(TOGGLE_LOADER, {state: false});
               })
            });
        },
        metaInfo: {
            title: 'Вход в личный кабинет'
        },
        data() {
            return {
                phone: "",
                password: "",
                phoneExternalStatus: STATUSES.EMPTY,
                passwordExternalStatus: STATUSES.EMPTY,
                phoneExternalError: {
                    haveError: false,
                    errorText: 'Такого пользователя не существует'
                },
                passwordExternalError: {
                    haveError: false,
                    errorText: 'Неверный пароль'
                },
            };
        },
        methods: {
            login: function () {
                let _this = this;
                let data = {
                    username: this.clearPhone,
                    password: this.password
                };
                this.$store.commit(TOGGLE_LOADER, {state: true});
                this.$http.post("/json/login", querystring.stringify(data)).then(
                    response => {

                        switch (response.status) {
                            case 200: {
                                _this.$router.push({name: "CabinetIndex", params:{lang: _this.$route.params.lang}});
                                if( !_this.$store.getters['profile/isInited'] ){
                                    _this.$store.dispatch('profile/INIT');
                                }
                                break;
                            }
                            case 401: {
                                _this.$validator.errors.add(
                                    'password',
                                    'Неверный логин или пароль'
                                );
                                break;
                            }
                            case 423: {
                                _this.$validator.errors.add(
                                    'password',
                                    'Аккаунт заблокирован'
                                );
                                break;
                            }
                        }
                    },
                    response => {
                        _this.errors.clear();
                        switch (response.response.status) {
                            case 401: {
                                _this.$validator.errors.add(
                                    'password',
                                    'Неверный логин или пароль'
                                );
                                _this.$validator.errors.add(
                                    'phone',
                                    ''
                                );
                                break;
                            }
                            case 423: {
                                _this.$validator.errors.add(
                                    'phone',
                                    ''
                                );
                                _this.$validator.errors.add(
                                    'password',
                                    'Аккаунт заблокирован'
                                );
                                break;
                            }
                        }
                        _this.$store.commit(TOGGLE_LOADER, {state: false});
                    }
                ).catch(response => {
                    _this.$store.commit(TOGGLE_LOADER, {state: false});
                    _this.passwordExternalStatus = STATUSES.LOAD_ERROR;
                    _this.phoneExternalError.haveError = true;
                    _this.phoneExternalError.errorText = '';
                    _this.passwordExternalError.haveError = true;
                    _this.passwordExternalError.errorText = 'Неверный логин или пароль'
                });
            },
        },
        computed: {
            clearPhone: function(){
                return this.phone.replace(/[^0-9.]/g, "");
            },
        },
        mounted() {
        }
    };
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";

    @import "~@/assets/scss/cabinet/desktop/form-wrap";
    @import "~@/assets/scss/cabinet/mobile/form-wrap";
    .content.content--cabinet {
        display: flex;
    }

    .router-link{
        font-size: 14px;
        display: inline-block;
        padding-top: 15px;
        text-align: center;
        color: #3083E2;
        text-decoration: underline;
    }
    .small-window {
        max-width: 768px;
        width: 100%;
        flex: 1;
        margin: 0 auto;
        border-radius: 15px;
        background: $white;
    }

    @media screen and (max-width: 1024px) {
        .small-window {
            margin: 35px auto 0;
        }
    }
    @media screen and (max-width: 780px){
        .small-window{
            border-radius: 0;
            margin: 0;
            max-width: 100%;
            width: 100%;
        }
    }
</style>
